let resolveReady: (() => void) | undefined;

/** Resolves when bootstrap finishes (success or fallback state). */
export const widgetReady = new Promise<void>((resolve) => {
  resolveReady = resolve;
});

export const resolveWidgetReady = () => {
  try {
    resolveReady?.();
    resolveReady = undefined;
  } catch (e) {
    console.error("[telekomId] resolveWidgetReady error:", e);
  }
};
